import { useSelector } from "react-redux";
import {
  generatePlaceOrderArray,
  getPlaceOrderItem,
} from "../utils/ordersController";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import APIExtensions from "../yoello-lib/modules/API/APIDefs";
import useAPI from "../yoello-lib/modules/API/useAPI";
import { useAuth0 } from "../yoello-lib/modules/auth/Auth0";
import { getCurrentEpochTime } from "../yoello-lib/modules/auth/epochTime";
// import { useSnackbarMessages } from "../yoello-lib/modules/components/snackbar/SnackbarContext";

export function useCheckCartItems() {
  const { retrieveToken } = useAuth0()!;
  const ExtraMenuItem = useSelector((state: any) => state.MenuItemsAsExtra);
  const orderType = useSelector((state: any) => state.SelectedMenuType);
  const Venue = useSelector((state: any) => state.Venue);
  const MenuExpireTime = useSelector((state: any) => state.MenuExpireTime);
  const cartItems = useSelector((state: any) => state.Cart);
  console.log(MenuExpireTime);
  // const { sendSnackbarMessage } = useSnackbarMessages();
  const { callAPI: getMenuItems } = useAPI<any>(
    APIExtensions.consumerMenu,
    retrieveToken,
    { onMountDisabled: true }
  );

  async function checkCartAvailability() {
    const disabledItems = [];
    if (getCurrentEpochTime() >= MenuExpireTime) {
      // sendSnackbarMessage(
      //   "Your menu item list is stale, we're just validating your cart items",
      //   "info"
      // );
      const placeOrderArray = generatePlaceOrderArray(cartItems, ExtraMenuItem);
      const menuBody = await getMenuItems(HTTPMethods.GET, {
        query: Venue.venue_nickname,
        params: { order_type: orderType },
      });
      const menuItems = menuBody.menu_items;
      const menuItemExtraGroups = menuBody.menu_item_extra_groups;
      const menuItemPreferencesGroups = menuBody.menu_item_preferences;
      const menuItemsAsExtras = menuBody.menu_items_as_extras;
      if (placeOrderArray.length > 0) {
        for (const item of placeOrderArray) {
          const orderItem = getPlaceOrderItem(
            item,
            menuItems,
            menuItemExtraGroups,
            menuItemPreferencesGroups,
            menuItemsAsExtras
          );
          if (orderItem.isDisabled) {
            const orderMenuItem = orderItem.menuItem as IMenuItem;
            disabledItems.push(orderMenuItem.menu_item_id);
          }
        }
      }
      if (disabledItems.length > 0) {
        return {
          isSuccess: false,
          disabledItems,
        };
      }
    }
    return {
      isSuccess: true,
      disabledItems,
    };
  }
  return {
    checkCartAvailability,
  };
}
